import styled from 'styled-components';

import { Container as BaseContainer } from '@shared';

export const PageWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 32px 0px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px 0px 16px 0px;

    .carRentalList__container {
      padding: 0px;
    }
  }
`;
export const SearchBarWrapper = styled(BaseContainer).attrs({
  noPadding: true,
})`
  display: flex;
  justify-content: center;
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    flex-direction: column;
  }
`;

export const SearchBarListContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
  padding: 24px 120px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.white};
`;
export const FilterAndResultContainer = styled.div<{ notFound?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 10px auto 0 auto;
  padding: 0;
  min-height: 45vh;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    margin: 30px auto 0 auto;
    display: grid;
    grid-template-columns: ${({ notFound }) =>
      notFound ? '420px 0' : '260px 960px'};
    justify-content: center;
    gap: 0 20px;
  }

  .carRentalList__notFound {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 3rem;
    padding: 0px 16px;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      margin-top: 0px;
      padding: 0px;
    }
  }
`;
